import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import Budget from '../../../widgets/budget/Budget'
import { getChangePayment } from '../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function EditPaymentPlanSave() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    //64A07968-1187-449B-BEED-C6D56E184391 projectId for get real schema
    // if (projectId === 'mock-projectManagement-review') {
    //   setSchema(mockSchema.model)
    // } else {
    handleGetSchema(projectId)
    // }
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getChangePayment(projectId)
      setSchema(_schema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={'แก้ไขงบประมาณโครงการ'} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.projectInfo} />
      <br />
      <Budget
        schema={schema.forms}
        isEditable={!schema.forms.disable}
        isHideBudgetPlan={true}
        isEditableBudgetInstallmentPlan={!schema.forms.disable}
        isShowBudgetSubmitButton={!schema.forms.disable}
        isEditWithdrawBudget={true}
      />
      <br />
    </SidebarProposal>
  )
}
